import React, { useEffect, useState } from "react";
import Link from "next/link";
import Footer from "../../../components/_App/Footer";
import Navbar from "../../../components/_App/Navbar1";
import PageBanner from "../../../components/Common/PageBanner";
import Head from "next/head";

//allCategories

const OfferingView = ({ offering, dataNav }) => {
  const [tabUrl, setTabUrl] = useState(null);
  // const [title, setTitle] = useState("");
  const [images, setImages] = useState(null);
  useEffect(() => {
    setTabUrl(window.location.href);
    // setTitle(document.title);
    setImages(document.images[0].src);
  }, []);

  return (
    <>
      <Navbar data={dataNav} />

      <PageBanner
        pageTitle={offering && offering.paths[1].name}
        homePageUrl="/"
        homePageText="Home"
        activePageText={
          offering &&
          offering.paths.map((path, index) => {
            const i = offering.paths.length - 1;
            return (
              <>
                {index == 0 ? (
                  <Link href="/current-affairs">
                    <a>{path.name}</a>
                  </Link>
                ) : (
                  <Link href="#">
                    <a>{path.name}</a>
                  </Link>
                )}
                {index !== i && " / "}
              </>
            );
          })
        }
      />

      {/* Rand section */}

      {/* <div className="row m-8">
        <div className="col-lg-4 col-sm-6 col-md-6">
          <a
            href="#"
            class="block p-6 max-w-xs bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
          >
            <div class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              Noteworthy
            </div>
            <div class="font-normal text-gray-700 dark:text-gray-400">
              Here are the biggest.
            </div>
          </a>
        </div>
      </div> */}

      <div>
        <Head>
          <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
          ></link>
          <title>Latest Current Affairs by ToppersNotes</title>
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <meta
            property="og:title"
            content="Latest Current Affairs by ToppersNotes"
          />
          <meta
            name="description"
            content="Save your most valuable time and prepare of the latest updated current affairs with ToppersNotes"
          />
          <meta
            property="og:description"
            content="Save your most valuable time and prepare of the latest updated current affairs with ToppersNotes"
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={tabUrl} />
          <meta property="og:image" content={images} />
          <link
            rel="canonical"
            // property="og:title"
            // content={offering.paths[1].name}
            // key="title"
            href={tabUrl}
          ></link>
        </Head>
      </div>

      <div className="container">
        <div className="row my-8">
          {offering
            ? offering.data.map((offer) => (
                <Link
                  href={
                    offer.has_subdirectories
                      ? `./english-current-affair/${offer.slug}`
                      : `#`
                  }
                >
                  <div className="col-lg-4 col-sm-6 col-md-6 text-center mb-10">
                    <a className="link-btn">
                      {/* single-categories-box */}
                      <div className="content max-w-xs mx-auto affairs-box rounded-lg">
                        {/* <img src="image" className=" h-42" alt="image" /> */}

                        <div className="px-3 py-6">
                          <h6 className="font-bold text-xl">{offer.name}</h6>
                          <span className="text-sm">
                            {offer.count} Articles
                          </span>
                        </div>
                        {/* <Link href={`/blog/months`}>
                    <a className="link-btn"></a>
                  </Link> */}

                        {/* {offer.has_subdirectories ? (
                    <Link href={`./offering/${offer.slug}`}>
                      <a className="link-btn"></a>
                    </Link>
                  ) : (
                    <Link href={`#`}>
                      <a className="link-btn"></a>
                    </Link>
                  )} */}
                        {/* <Link href={`/categories/${categories.slug}`}>
                    <a className="link-btn"></a>
                  </Link> */}
                      </div>
                    </a>
                  </div>
                </Link>
              ))
            : "Loading"}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OfferingView;

export async function getStaticProps() {
  const res = await fetch(
    `https://api.toppersnotes.com/api/ca/get-offering-directories?offering_slug=english-current-affairs`
  );

  const offering = await res.json();

  if (!offering) {
    return {
      notFound: true,
    };
  }

  return {
    props: { offering },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 86400, // In seconds
  };
}
